import BaseHasPermission from "./BaseHasPermission.vue";

export default BaseHasPermission;
